import { API_URL } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";
import { getAffariCanal, getAffariListaPrecioBase, getAffariAlmacen } from "./authService";

export const getProductos = api("getProductos", ({ descripcion, start, length }) => {
    const params = new URLSearchParams({ descripcion, start: String(start), length: String(length) });
    return `${API_URL}productos?${params.toString()}`;
});

export const getPrecio = api("getPrecio", (codigo, listaPrecio) => `${API_URL}precio?codigo=${codigo}&listaPrecio=${listaPrecio}`);

export const getPrecios = api("getPrecios", ({
    dialog = false,
    draw = 1,
    id,
    search = "",
    length = 20,
    old = false,
    start = 1,
    tipo = "",
}) => `${API_URL}precios?${buildQuery({
    dialog: String(dialog),
    draw: String(draw),
    id: String(id),
    "search[value]": search,
    length: String(length),
    old: String(old),
    start: String(start),
    tipo: tipo || getAffariCanal(),
})}`);

export const getAlmacenes = api("getAlmacenes", () => `${API_URL}cache/sucursales`);

export const getCatalogo = api("getCatalogo", ({
    almacen = getAffariAlmacen(),
    atributos = "",
    descripcion = "",
    familia = 0,
    fotos = true,
    length = 20,
    listaPrecio = "",
    precios = true,
    start = 0,
    stocks = true,
    tipo = ""
}) => {
    const serializedAtributos = typeof atributos === "string"
        ? atributos
        : Object.keys(atributos || {}).length
            ? JSON.stringify(atributos)
            : "";
    const resolvedListaPrecio = String(listaPrecio || "").trim() || getAffariListaPrecioBase();
    const resolvedTipo = tipo || getAffariCanal();
    if (!resolvedTipo) {
        throw new Error("No se pudo determinar el canal (B2B/B2C) de la sesión; el parámetro 'tipo' es obligatorio.");
    }
    const params = new URLSearchParams({
        almacen: String(almacen),
        atributos: serializedAtributos,
        descripcion: String(descripcion),
        familia: String(familia),
        fotos: String(fotos),
        length: String(length),
        listaPrecio: resolvedListaPrecio,
        precios: String(precios),
        start: String(start),
        stocks: String(stocks),
        filtroStock: "todos",
        tipo: resolvedTipo,
    });
    return `${API_URL}productos?${params.toString()}`;
}, { headers: { Accept: "application/json" } });

// export const getAtributos = api("getAtributos", (familia) => `${API_URL}atributos?familia=${familia}`);

/* ATRIBUTOS (Cabecera maestra) */
export const getAtributosFamilia = api("getAtributosFamilia", (idFamilia) => `${API_URL}atributos/familia?id_familia=${idFamilia}`);
export const getAtributo = api("getAtributo", (id) => `${API_URL}atributos/obtener?id=${id}`);
export const grabarAtributo = api("grabarAtributo", (data) => `${API_URL}atributos/grabar?${buildQuery({
    id: data?.id,
    id_familia: data?.id_familia,
    llave: data?.llave,
    tipo_dato: data?.tipo_dato,
})}`);
export const eliminarAtributo = api("eliminarAtributo", (id) => `${API_URL}atributos/eliminar?id=${id}`);

/* VALORES DE ATRIBUTOS (Detalle) */
export const getValoresAtributo = api("getValoresAtributo", (idAtributo) => `${API_URL}atributos/valores?id_atributo=${idAtributo}`);
export const getValorAtributo = api("getValorAtributo", (id) => `${API_URL}atributos/valor/obtener?id=${id}`);
export const grabarValorAtributo = api("grabarValorAtributo", (data) => `${API_URL}atributos/valor/grabar?${buildQuery({
    id: data?.id,
    id_atributo: data?.id_atributo,
    valor: data?.valor,
})}`);
export const eliminarValorAtributo = api("eliminarValorAtributo", (id) => `${API_URL}atributos/valor/eliminar?id=${id}`);

// /* Alias legacy: catálogo consume lista de atributos por familia */
// export const getAtributos = getAtributosFamilia;

export const getFamilias = api("getFamilias", ({ tipo = "" } = {}) => {
    const resolvedTipo = tipo || getAffariCanal();
    return `${API_URL}familias/lista?tipo=${encodeURIComponent(resolvedTipo)}`;
});

export const getFamiliasAll = api("getFamiliasAll", ({ tipo = "", activas = false } = {}) => {
    const resolvedTipo = tipo || getAffariCanal();
    const params = new URLSearchParams({ tipo: resolvedTipo });
    if (activas) params.append('activas', 'true');
    return `${API_URL}familias/all?${params.toString()}`;
});

export const activarFamilia = api("activarFamilia", (id, tipo) => `${API_URL}familias/activar?id=${id}&tipo=${tipo}`);
export const bajarFamilia = api("bajarFamilia", (id, tipo) => `${API_URL}familias/bajar?id=${id}&tipo=${tipo}`);
export const desactivarFamilia = api("desactivarFamilia", (id, tipo) => `${API_URL}familias/desactivar?id=${id}&tipo=${tipo}`);
export const eliminarFamilia = api("eliminarFamilia", (id, tipo) => `${API_URL}familias/eliminar?id=${id}&tipo=${tipo}`);
export const grabarFamilia = api("grabarFamilia", (params) => `${API_URL}familias/grabar?${new URLSearchParams(params).toString()}`);
export const subirFamilia = api("subirFamilia", (id, tipo) => `${API_URL}familias/subir?id=${id}&tipo=${tipo}`);
export const refreshFamiliasCache = api("refreshFamiliasCache", () => `${API_URL}cache/familias/refresh`);

export const getAlmacen = api("getAlmacen", (id, almacen) => `${API_URL}cotizacion/almacen?almacen=${encodeURIComponent(almacen ?? "")}&id=${id}`);
